function addScript(src = '', attributeIn = {}) {
  if (src === '') {
    return Promise.reject();
  }

  const attribute = {
    src,
    type: 'text/javascript',
    async: true,
    defer: true,
    ...attributeIn
  };

  const element = document.createElement('script');

  for (const attr in attribute) {
    element.setAttribute(attr, attribute[attr] ? attribute[attr] : null);
  }

  return new Promise((resolve, reject) => {
    element.onload = () => {
      resolve();
    };

    document.body.appendChild(element);
  });
}

export default {
  add: addScript
};
